import { Typography } from "@material-ui/core"
import styled from "styled-components"
import { StyledRow, StyledSvgIcon } from "theme/shared"

const StyledText = styled(Typography).attrs({ variant: "body2" })`
  font-size: 16px;
  color: ${(p) => p.theme.colors.black};
`
const StyledList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`
const StyledLi = styled.li`
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
`
type BulletsListProps = {
  textList: string[]
}

const BulletsList = ({ textList }: BulletsListProps) => {
  return (
    <StyledList>
      {textList.map((text, index) => (
        <StyledLi key={index}>
          <StyledRow $fullWidth $gap="4px" $notCenter>
            <StyledSvgIcon
              src="/icons/fi_circle_bullet.svg"
              alt="bullet-icon"
              w={16}
              h={16}
            />
            <StyledText>{text}</StyledText>
          </StyledRow>
        </StyledLi>
      ))}
    </StyledList>
  )
}

export default BulletsList
